import { PhoneInput, isValidPhone } from "@/components/shared/PhoneInput";

import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { AuthShell, authInput, authButton } from "@/components/auth/AuthShell";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!isValidPhone(form.phone)) return toast.error("Enter a valid phone number with country code");
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created");
      navigate("/portal");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow="Join Aurelia"
      title="Create your account"
      subtitle="One profile to apply, upload documents, and track every application."
      image="https://images.unsplash.com/photo-1631049307290-bb947b114627?crop=entropy&cs=srgb&fm=jpg&q=85"
    >
      <form onSubmit={submit} className="space-y-4">
        <input required placeholder="Full name" value={form.name} onChange={set("name")} className={authInput} data-testid="register-name" />
        <input type="email" required placeholder="Email" value={form.email} onChange={set("email")} className={authInput} data-testid="register-email" />
        <PhoneInput value={form.phone} onChange={(v) => setForm({ ...form, phone: v })} className={authInput} testid="register-phone" required />
        <input type="password" required minLength={6} placeholder="Password (min 6 chars)" value={form.password} onChange={set("password")} className={authInput} data-testid="register-password" />
        <button type="submit" disabled={loading} className={authButton} data-testid="register-submit">
          {loading ? "Creating…" : "Create Account"}
        </button>
      </form>
      <p className="mt-8 text-center font-sans text-sm text-[var(--aur-text-2)]">
        Already registered? <Link to="/login" className="text-gold hover:text-gold-bright">Sign in</Link>
      </p>
    </AuthShell>
  );
}
